import React, { useState } from "react";

export default function PriceField({ value, onChange, tooltipSide = "right", tooltipTop = 52, ...props }) {

	const [editing, setEditing] = useState(false);

	return <div className="priceField">
		<input type="text"
			{...props}
			value={editing ? String(value) : `£${(value / 100).toFixed(2)}`}
			onFocus={e => {
				setEditing(true);
				const target = e.target;
				setTimeout(() => {
					target.select()
				}, 50)
			}}
			onBlur={e => setEditing(false)}
			onChange={e => {
				onChange(Number(e.target.value) || 0);
			}}
		/>
		{editing && <div className={`tooltip tooltip-${tooltipSide}`} style={{
			top: tooltipTop
		}}>
			Enter value in pence. For example, £5.00 would be "500".
		</div>}
	</div>

}